import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import SidePanel from '@welldev-group/rcl-sidepanel';
import Segment from 'sharedWebpack/ItemWrapper/Flight/Segment';
import './styles.scss';

const TripSegmentSidePanel = props => {
  const {
    title,
    group,
    findAirport,
    findAirline,
    showTripSegment,
    aircraftInformation,
    fetchAircraftType,
  } = props;

  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const allSegmentsInformation =
    group &&
    group.segments &&
    group.segments.map(segment => (
      <Segment
        key={`${segment.originCode}-${segment.destinationCode}`}
        segment={segment}
        stopovers={group.stopovers}
        findAirport={findAirport}
        findAirline={findAirline}
        loadAircraft={showTripSegment}
        aircraftInformation={aircraftInformation}
        fetchAircraftType={fetchAircraftType}
      />
    ));

  const allSegmentsBody = allSegmentsInformation || null;

  const handleOpen = () => {
    setIsPanelOpen(true);
  };

  const handleClose = () => {
    setIsPanelOpen(false);
  };

  return (
    <Fragment>
      <span
        className="trip-segment-side-panel__placeholder"
        onClick={handleOpen}
        role="button"
        tabIndex={0}
        onKeyPress={() => {}}
      >
        {I18n.t('admin.components.orders.items_tab.placeholder.show_itinerary')}
      </span>

      <SidePanel
        className="trip-segment-side-panel__body"
        title={title}
        isOpened={isPanelOpen}
        onOpen={handleOpen}
        onClose={handleClose}
      >
        {allSegmentsBody}
      </SidePanel>
    </Fragment>
  );
};

TripSegmentSidePanel.defaultProps = {
  findAirline: () => {},
  aircraftInformation: {},
  fetchAircraftType: () => {},
};

TripSegmentSidePanel.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  group: PropTypes.shape({
    segments: PropTypes.arrayOf(
      PropTypes.shape({
        originCode: PropTypes.string,
        destinationCode: PropTypes.string,
      }),
    ),
    stopovers: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  findAirport: PropTypes.func.isRequired,
  findAirline: PropTypes.func,
  showTripSegment: PropTypes.bool.isRequired,
  aircraftInformation: PropTypes.shape({}),
  fetchAircraftType: PropTypes.func,
};

export default TripSegmentSidePanel;
